import React from 'react';

export default function LoginModal({
  visible,
  username,
  password,
  onUsernameChange,
  onPasswordChange,
  onSubmit,
  onCancel,
  isLoggingIn,
  error,
}) {
  if (!visible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded shadow w-80">
        <h2 className="text-lg font-semibold mb-4">Admin Login</h2>
        <input
          type="text"
          placeholder="Username"
          className="border w-full p-2 mb-2"
          value={username}
          onChange={(e) => onUsernameChange(e.target.value)}
          aria-label="Username"
        />
        <input
          type="password"
          placeholder="Password"
          className="border w-full p-2 mb-4"
          value={password}
          onChange={(e) => onPasswordChange(e.target.value)}
          aria-label="Password"
        />
        <div className="flex justify-between">
          <button
            onClick={onSubmit}
            disabled={isLoggingIn}
            className="bg-indigo-600 text-white px-4 py-2 rounded disabled:opacity-60"
          >
            {isLoggingIn ? 'Logging in...' : 'Login'}
          </button>
          <button onClick={onCancel} className="text-gray-500 px-4 py-2">
            Cancel
          </button>
        </div>
        {error ? <p className="mt-3 text-sm text-red-600">{error}</p> : null}
      </div>
    </div>
  );
}
